<template>
  <!--<a class="button" v-bind:href="linkPath">READMORE →</a>-->
  <a v-bind:href="linkPath"><img class="button-img" src="../assets/ButtonReadMore.png" alt="ReadMoreボタン"></a>
</template>

<script>
export default {
  name: 'ButtonReadMore',
  props:['linkPath'],
}
</script>

<style scoped>
  .button{
    background-color: var(--accent-color);
    color: var(--main-color)
  }

    .button-img{
      width: 100%;
      object-fit: contain;
    }

    .button-img:hover{
      opacity: 0.8;
      /*width: 110%;*/
      transform: scale(1.1, 1.1);
      transition:0.3s ease-in-out;
    }

   /* PC表示 */
  @media screen and (min-width:821px){
    /*.button-img{
      width:18vw;
      object-fit: contain;
    }

    .button-img:hover{
      opacity: 0.8;
      width: 22vw;
      transition:0.3s ease-in-out;
    }*/
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    /*.button-img{
      object-fit: contain;
    }

    .button-img:hover{
      opacity: 0.8;
      width: 200%;
      transition:0.3s ease-in-out;
    }*/
  }
</style>